export const weAreArshContent = {
    title: ["We Are", "The ARSH", "Industries"],

    paragraphs: [
        "ARSH Industries FZ LLC is a UAE-based manufacturer specializing in premium tipping paper, cigarette packaging materials, and high-precision printing components.",

        "With advanced converting facilities in Ras Al Khaimah and technical hubs in India, we deliver precision, consistency, and customized branding solutions for global tobacco brands.",

        "Our focus on quality, innovation, and ethical manufacturing drives every process — from material sourcing to final delivery. Trusted by brands across 20+ countries, ARSH stands for reliability, performance, and partnership you can count on.",
    ],
};